import { PointsProductGiftItemExchangePage, PointsRedeemPage, PointsAuditPage, PointProductGiftItemPage, PointsActivityPage } from '@Local/Points/';
import {
    POINTS_OVERVIEW_ROUTER,
    POINTS_REDEEM_OVERVIEW_ROUTER,
    POINTS_PRODUCT_GIFT_OVERVIEW_ROUTER,
    POINTS_ACTIVITY_OVERVIEW_ROUTER,
    POINTS_AUDIT_OVERVIEW_ON_TRIAL_ROUTER,
    POINTS_AUDIT_OVERVIEW_TYPE_ROUTER,
} from '@Router/routerPath';
import { FRONT_KEY } from '@Constants/frontKey';

const pointsRouter = [
    {
        description: '點數管理',
        frontKey: FRONT_KEY.POINTS,
    },
    {
        description: '會員點數總覽',
        frontKey: FRONT_KEY.POINTS_OVERVIEW,
        static: true,
        path: POINTS_OVERVIEW_ROUTER,
        href: POINTS_OVERVIEW_ROUTER,
        as: PointsRedeemPage,
    },
    {
        description: '贈品兌換總覽',
        frontKey: FRONT_KEY.POINTS_REDEEM_OVERVIEW,
        static: true,
        path: POINTS_REDEEM_OVERVIEW_ROUTER,
        href: POINTS_REDEEM_OVERVIEW_ROUTER,
        as: PointsProductGiftItemExchangePage,
    },
    {
        description: '點數活動總覽',
        frontKey: FRONT_KEY.POINTS_ACTIVITY_OVERVIEW,
        static: true,
        path: POINTS_ACTIVITY_OVERVIEW_ROUTER,
        href: POINTS_ACTIVITY_OVERVIEW_ROUTER,
        as: PointsActivityPage,
    },
    {
        description: '兌換品總覽',
        frontKey: FRONT_KEY.POINTS_PRODUCT_GIFT_OVERVIEW,
        static: true,
        path: POINTS_PRODUCT_GIFT_OVERVIEW_ROUTER,
        href: POINTS_PRODUCT_GIFT_OVERVIEW_ROUTER,
        as: PointProductGiftItemPage,
    },
    {
        description: '點數審核總覽',
        frontKey: FRONT_KEY.POINTS_AUDIT_OVERVIEW,
        exact: true,
        path: POINTS_AUDIT_OVERVIEW_TYPE_ROUTER,
        href: POINTS_AUDIT_OVERVIEW_ON_TRIAL_ROUTER,
        as: PointsAuditPage,
    },
];

export default pointsRouter;
